var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransporte2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.718,
    height: 45.208,
    viewBox: "0 0 46.718 45.208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f5f5f5;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transporte_White",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3102",
    "data-name": "Path 3102",
    className: "cls-1",
    d: "M12.211,39.425v2.331A3.225,3.225,0,0,1,8.8,45.208a3.151,3.151,0,0,1-3.366-3.371c-.02-.786,0-1.574,0-2.342-1.657-.377-1.657-.377-1.657-2.067V26.949H1.227A1.083,1.083,0,0,1,0,25.714q.02-3.924,0-7.848c0-.854.426-1.214,1.236-1.216s1.624,0,2.537,0V5.151C3.783,1.9,5.688,0,8.947,0H37.773c3.259,0,5.17,1.9,5.179,5.135v11.5H45.3c1.13.013,1.418.287,1.42,1.394V25.6c0,1-.309,1.317-1.295,1.336-.786.018-1.569,0-2.465,0V37.692c0,1.418-.105,1.536-1.659,1.742v2.3a3.184,3.184,0,0,1-3.373,3.472,3.2,3.2,0,0,1-3.4-3.445c-.013-.755,0-1.512,0-2.331ZM41.038,11.306H5.706V25.038H14.82c-1.824-.724-3.667-1.317-5.511-1.907-.634-.2-1.174-.522-.928-1.293s.878-.693,1.505-.492c1.879.6,3.794,1.1,5.625,1.832A26.742,26.742,0,0,0,27.7,25.117c.878-.07,1.756,0,2.633,0a.621.621,0,0,0-.4-.327c-1.732-.557-3.467-1.1-5.2-1.679-.841-.279-1.161-.935-.755-1.5s.946-.41,1.484-.237c3.465,1.117,6.9,2.333,10.409,3.3a34.652,34.652,0,0,0,5.155.614ZM5.684,37.406H41.038V27.022H5.684ZM41.078,9.292V5.252c0-2.381-.988-3.362-3.393-3.364H12.509c-1.429,0-2.853-.029-4.286.046A2.542,2.542,0,0,0,5.706,4.17C5.6,5.857,5.677,7.556,5.677,9.3ZM1.909,18.584V25H3.665V18.584Zm41.166,0V25h1.732V18.586ZM7.3,39.4c0,.974-.035,1.852,0,2.728.042.814.577,1.148,1.345,1.185.952.046,1.556-.292,1.624-1.075.079-.926.018-1.865.018-2.838Zm32.133.033H36.43c0,.948-.05,1.828.013,2.7s.634,1.227,1.622,1.181c.81-.037,1.339-.4,1.365-1.26s0-1.692,0-2.618Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3103",
    "data-name": "Path 3103",
    className: "cls-1",
    d: "M41.643,60.223h-6.1a2.088,2.088,0,0,1-.974-.136,1.031,1.031,0,0,1-.52-.748,1.247,1.247,0,0,1,.5-.871,1.827,1.827,0,0,1,.968-.149H48.169c.571.055,1.025.279,1.034.924s-.439.906-1.007.941c-.514.033-1.029.018-1.536.018Z",
    transform: "translate(-26.577 -45.519)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3104",
    "data-name": "Path 3104",
    className: "cls-1",
    d: "M113.864,60.1c-1.236.026-1.771-.266-1.685-.963.129-1.047.968-.878,1.681-.9.3,0,.674-.09.878.05.356.219.794.593.845.946.033.248-.489.645-.838.843C114.527,60.208,114.167,60.1,113.864,60.1Z",
    transform: "translate(-87.553 -45.436)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3105",
    "data-name": "Path 3105",
    className: "cls-1",
    d: "M39.542,139.434a2.977,2.977,0,1,1,2.965-2.928,2.91,2.91,0,0,1-2.965,2.928Zm.219-4.139h-.417a4.351,4.351,0,0,0-.8,1.216c-.143.551.509,1.1,1.1,1.04.63-.07,1.078-.476.95-1.084-.079-.421-.529-.779-.819-1.172Z",
    transform: "translate(-28.602 -104.203)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3106",
    "data-name": "Path 3106",
    className: "cls-1",
    d: "M152.458,139.693a2.9,2.9,0,0,1-2.868-2.93,2.926,2.926,0,1,1,2.868,2.93Zm-.136-1.71.419-.013c.277-.4.722-.775.788-1.207.09-.6-.373-1-1-1.049-.586-.044-1.209.544-1.047,1.1a4.566,4.566,0,0,0,.834,1.172Z",
    transform: "translate(-116.761 -104.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3107",
    "data-name": "Path 3107",
    className: "cls-1",
    d: "M65.128,18.881H55.007c-1.236,0-1.486-.252-1.5-1.5V14.922c0-.821.36-1.242,1.209-1.242H75.6c.836,0,1.227.382,1.211,1.225-.02.911,0,1.824,0,2.737s-.312,1.231-1.282,1.233h-10.4Zm-9.685-1.933H74.89V15.616H55.443Z",
    transform: "translate(-41.767 -10.678)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporte2);
export default __webpack_public_path__ + "static/media/Transporte2.848aac5bc9e8fb4b33ab3e87787070ae.svg";
export { ForwardRef as ReactComponent };